import React, { createContext, useContext, useMemo, useState } from "react";

type PublicState = {
  questionId?: number;
}

const ContextPublic = createContext<PublicState>({
  questionId: undefined
});

export const usePublic = () => useContext(ContextPublic);

export const PublicProvider: React.FC = ({ children }) => {
  const [state, setState] = useState<PublicState>({
    questionId: undefined
  });
  const setQuestionId = (questionId: number) => setState(
    prev => ({ ...prev, questionId }));

  const value = useMemo(() => ({
    ...state,
    setQuestionId
  }), [state]);

  return (
    <ContextPublic.Provider value={value}>
      {children}
    </ContextPublic.Provider>
  );
};
